import logo from '../images/logo-black.svg';

function NotFound() {
  return (
    <section className="login">
      <div className="container">
        <form className="form">
          <div className="form__logo">
            <img src={logo} className="logo" alt="logo" />
          </div>
          <div className="form__row">
            Nem található a keresett oldal.
          </div>
        </form>
      </div>
    </section>
  );
}

export default NotFound;
